// Экран вместо содержимого, когда показать нечего: нет связи, заказ не найден, нет такой
// страницы. Что случилось и что делать — одной кнопкой.
import type { ReactNode } from "react";
import { Button } from "./Button";
import { Icon, type IconName } from "./icons";
import { Screen } from "./Screen";

export function ProblemScreen({
  icon,
  title,
  children,
  action,
}: {
  icon: IconName;
  title: string;
  children: ReactNode;
  action: { text: string; to?: string; onClick?: () => void };
}) {
  return (
    <Screen>
      <div style={{ display: "flex", flexDirection: "column", gap: 14, maxWidth: 480, width: "100%", margin: "0 auto", paddingTop: 24 }}>
        <span
          aria-hidden="true"
          style={{ width: 56, height: 56, borderRadius: "50%", background: "var(--sunken)", color: "var(--ink2)", display: "flex", alignItems: "center", justifyContent: "center" }}
        >
          <Icon name={icon} size={26} />
        </span>
        <h1 className="h2">{title}</h1>
        <p className="text muted">{children}</p>
        <Button to={action.to} onClick={action.onClick}>
          {action.text}
        </Button>
      </div>
    </Screen>
  );
}

export function NotFoundScreen() {
  return (
    <ProblemScreen icon="alert" title="Такой страницы нет" action={{ text: "На главную", to: "/" }}>
      Проверь ссылку — или начни с главной.
    </ProblemScreen>
  );
}
